"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = record;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ACTION_UPDATE = 'rec.update';
var ACTION_REPLACE = 'rec.replace';
var ACTION_CLEAR = 'rec.clear';

function createReducer(scope) {
  return function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    if (action.scope !== scope) return state;

    switch (action.type) {
      case ACTION_UPDATE:
        if (state === null) return action.payload;
        return _objectSpread({}, state, action.payload);

      case ACTION_REPLACE:
        return action.payload;

      case ACTION_CLEAR:
        return null;

      default:
        return state;
    }
  };
}

function createSelector(getState) {
  return {
    get: getState
  };
}

function createActor(scope, dispatch) {
  return {
    update: function update(item) {
      return dispatch({
        scope: scope,
        type: ACTION_UPDATE,
        payload: item
      });
    },
    replace: function replace(item) {
      return dispatch({
        scope: scope,
        type: ACTION_REPLACE,
        payload: item
      });
    },
    clear: function clear() {
      return dispatch({
        scope: scope,
        type: ACTION_CLEAR
      });
    }
  };
}

function record(scope) {
  return {
    name: scope,
    getReducer: function getReducer() {
      return createReducer(scope);
    },
    getSelector: function getSelector(getState) {
      return createSelector(getState);
    },
    getActor: function getActor(dispatch) {
      return createActor(scope, dispatch);
    },
    onSave: function onSave(state) {
      return state;
    },
    onRestore: function onRestore(state) {
      return state;
    }
  };
}